import React from 'react';
import { withRouter } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';

//COMPONENTS
import {Row, Column, IBox, Title, Content, Return} from '../inspinia'
import Pagination from "react-js-pagination";

class ListaDetalhe extends React.PureComponent
{
    constructor(props)
    {
        super(props);     
        
        this.state = 
        {
            idListaContato: props.match.params.id,
            loading: false, filter: "", page: 0,
            data:
            {
                id: props.match.params.id, nomeListaContato: "", quantidadeContato: 0, dataCadastro: ""
            },
            list: 
            {
                currentPage: 1, pageCount: 0, pageSize: 0, rowCount: 0, results: undefined
            }
        }

        this.handleBuscarInput = this.handleBuscarInput.bind(this); 
        this.handleBuscarClick = this.handleBuscarClick.bind(this); 
        this.handlePageChange  = this.handlePageChange.bind(this);
    }

    componentDidMount()
    {
        this.LoadData();
        this.LoadTable();
    }

    handleBuscarInput(e)
    {
        this.setState({ ...this.state, filter: e.target.value });   
    }

    handleBuscarClick()
    {
        this.setState({ ...this.state, page: 1 }, this.LoadTable());      
    }

    handlePageChange(pageNumber) 
    {
        this.state.page = pageNumber;
        this.setState({ ...this.state, page: pageNumber}, this.LoadTable(this.state.page));
    }

    render()
    {
        return (            
            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-4">
                    <Column>                   
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">{this.state.data.nomeListaContato} - Listas de Contatos</h3>
                            </Title>

                            <Content>
                                {/* MENU DE OPÇÕES */}
                                <Row className="m-0 mb-3">
                                    <Column size="9" className="p-0 mx-auto container">
                                        
                                        <h5 className="text-black font-weight-normal">Contatos Ativos: {this.state.data.quantidadeContato}  •  Criado: {this.state.data.dataCadastro}</h5>
                                    
                                    </Column>

                                    <Column size="3" className="p-0 mx-auto container">                                     

                                    </Column>
                                </Row>

                                {/* TABELA */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0 table-responsive">
                                        
                                        <Table data={this.state.list} history={this.props.history}/>                                        
                                    
                                    </Column>
                                </Row>
                            </Content>
                        </IBox>                        
                    </Column>
                </Row>

                {/* FOOTER */}
                <Row className="mb-5">
                    <Column className="container">
                        <Row>
                            <Column size="4" className="text-left">
                                <div className="d-flex justify-content-start">                       
                                    
                                    <Return to={c.CAMPAIGN_ROUTE+"/lista"} width="130px" />

                                </div> 
                            </Column>

                            <Column size="4" className="text-center">
                                <div className="d-flex justify-content-center">
                                    
                                    <Pagination
                                        hideNavigation
                                        pageRangeDisplayed={5}
                                        activePage={this.state.page}
                                        itemsCountPerPage={this.state.list.pageSize}
                                        totalItemsCount={this.state.list.rowCount}
                                        onChange={this.handlePageChange}
                                    />

                                </div>    
                            </Column>
                        </Row>                     
                    </Column>
                </Row>
                
            </div>
        );
    }
 
    LoadData()
    {
        let self = this;
        let id = this.state.idListaContato;

        const url = `${ c.API_BASE_URL }/contactDados/${id}`;
        const options =
        {
            method: 'GET' // method: 'POST'
            ,headers: { 'Content-Type': 'application/json' }
            //,body: JSON.stringify(user)
        };

        callApi(url, options, function(response)
        { 
            self.setState({...self.state, data: response});
        });
    }

    LoadTable(pageNumber)
    {
        let self = this;
        let id = this.state.idListaContato;
        let page = --pageNumber;

        const url = `${ c.API_BASE_URL }/researchContacts`;
        const options =
        {
            method: 'POST'
            ,headers: { 'Content-Type': 'application/json' }
            ,body: JSON.stringify({
                idListaContato: id,
                page: page
            })
        };
    
        self.setState({...self.state, loading: true})

        callApi(url, options, function(response)
        { 
            self.setState({...self.state, loading: false, list: response});
        });
    }
}

class Table extends React.Component
{
    render()
    {    
        const data = this.props.data; let html = "";

        if (data.results === undefined)
        {
            html = (<tr><td colSpan="7" scope="row">Carregando...</td></tr>);
        }
        else if (data.results.length === 0)
        {
            html = (<tr><td colSpan="7" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.results.length   > 0)
        {
            html = data.results.map(row =>
                <tr key={row.id} id={row.id}>
                    <td>{row.id}</td>
                    <td>{row.nome}</td>
                    <td>{row.email}</td>
                    <td>{row.dataCadastro}</td>                   
                </tr>                  
            );
        }

        return(
            <table className="footable table table-striped toggle-arrow-tiny text-body">
                <thead>
                    <tr style={{backgroundColor: "#dbf1e9"}}>       
                        <th>Código</th>
                        <th>Nome do contato</th>
                        <th>Contato</th>
                        <th>Data</th>
                    </tr>
                </thead>

                <tbody>{html}</tbody>
            </table>
        )
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ListaDetalhe));
